import type { TonPastille } from '../ui/Primitives';
import type { Delai, StatutReclamation } from '../../lib/useReclamations';

/** Pastille du statut, aux tons de la maquette : nouvelle, en instruction, clôturée. */
export function tonStatut(statut: StatutReclamation): TonPastille {
  if (statut === 'NOUVELLE') return 'warning';
  if (statut === 'EN_INSTRUCTION') return 'info';
  return 'success';
}

function jours(nombre: number): string {
  return `${nombre} jour${nombre > 1 ? 's' : ''}`;
}

/** « Clôturée en 4 jours », « Ouverte depuis 12 jours · hors délai ». */
export function delaiLisible(reclamation: { statut: StatutReclamation; delai: Delai }): string {
  const { delai } = reclamation;
  const base =
    reclamation.statut === 'CLOTUREE'
      ? `Clôturée en ${jours(delai.jours)}`
      : delai.jours === 0
        ? 'Reçue aujourd’hui'
        : `Ouverte depuis ${jours(delai.jours)}`;
  return delai.horsDelai ? `${base} · hors délai` : base;
}
